const motionSafe = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const isProductPage = document.body.classList.contains("template-product");
const mobileEffectsLite = window.matchMedia("(max-width: 980px), (pointer: coarse)").matches;
const lowPowerDevice =
  mobileEffectsLite ||
  (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
  (navigator.deviceMemory && navigator.deviceMemory <= 4);

document.documentElement.classList.toggle("effects-lite", lowPowerDevice);
document.documentElement.classList.toggle("mobile-effects-lite", mobileEffectsLite);

const parallaxItems = motionSafe && !isProductPage && !lowPowerDevice ? document.querySelectorAll("[data-speed]") : [];
const parallaxEntries = Array.from(parallaxItems, (item) => ({
  element: item,
  speed: Number(item.dataset.speed) || 0,
  depthX: Number(item.dataset.depthX) || 0,
  depthY: Number(item.dataset.depthY) || 0,
}));
const revealItems = document.querySelectorAll(".reveal");
const galleryPieces = document.querySelectorAll(".gallery-piece");
const galleryLightbox = document.querySelector(".gallery-lightbox");
const galleryLightboxArt = document.querySelector(".gallery-lightbox__art");
const galleryLightboxTitle = document.querySelector(".gallery-lightbox__title");
const galleryLightboxMedium = document.querySelector(".gallery-lightbox__medium");
const galleryCloseTriggers = document.querySelectorAll("[data-gallery-close]");
const galleryFilterButtons = document.querySelectorAll("[data-gallery-filter]");
const galleryOpenButton = document.querySelector("[data-gallery-open]");
const galleryFocusArt = document.querySelector("[data-gallery-focus-art]");
const galleryFocusTitle = document.querySelector("[data-gallery-focus-title]");
const galleryFocusMedium = document.querySelector("[data-gallery-focus-medium]");
const galleryFocusStatus = document.querySelector("[data-gallery-focus-status]");
const galleryFocusAura = document.querySelector("[data-gallery-focus-aura]");
const galleryFocusCount = document.querySelector("[data-gallery-focus-count]");
const galleryWall = document.querySelector(".gallery-wall");
const galleryRuneStage = document.querySelector(".gallery-rune-stage");
const productGalleryMain = document.querySelector("[data-product-gallery-main]");
const productGalleryThumbs = document.querySelectorAll("[data-product-gallery-thumb]");
const productGalleryFrame = productGalleryMain?.closest(".product-gallery__image-wrap");
const siteHeader = document.querySelector("[data-site-header]");
const headerRankBadge = document.querySelector("[data-header-rank]");
const mediaLightbox = document.querySelector(".media-lightbox");
const mediaLightboxImage = document.querySelector(".media-lightbox__image");
const mediaCloseTriggers = document.querySelectorAll("[data-media-close]");
const productForms = document.querySelectorAll("[data-product-form]");
const astralProductMaps = document.querySelectorAll("[data-astral-product-map]");
const cartForm = document.querySelector("[data-cart-form]");
const cartTotal = document.querySelector("[data-cart-total]");
const cartCount = document.querySelector(".site-nav__cart-count");
const crystalCursor = document.querySelector(".crystal-cursor");
const battleVignette = document.querySelector(".battle-vignette");
const commandButtons = document.querySelectorAll("[data-command]");
const secretBoonForms = document.querySelectorAll("[data-secret-boon]");
const introScreen = document.querySelector("[data-intro-screen]");

let scrollY = window.scrollY;
let pointerX = 0;
let pointerY = 0;
let frameQueued = false;
let lastScrollY = scrollY;
let headerIdleTimer;
let activeGalleryPiece = null;

const updateParallax = () => {
  if (!parallaxEntries.length) {
    return;
  }

  parallaxEntries.forEach(({ element, speed, depthX, depthY }) => {
    const effectiveSpeed = lowPowerDevice ? 0 : speed;
    element.style.setProperty("--parallax-shift", `${scrollY * effectiveSpeed}px`);
    element.style.setProperty("--parallax-x", `${pointerX * depthX}px`);
    element.style.setProperty("--parallax-y", `${pointerY * depthY}px`);
  });

  document.documentElement.style.setProperty("--scroll-phase", `${scrollY * (lowPowerDevice ? 0 : 0.02)}deg`);
};

const createAetherMotes = () => {
  if (!motionSafe || lowPowerDevice) {
    return;
  }

  const fragment = document.createDocumentFragment();
  const moteCount = window.innerWidth > 1280 ? 24 : 16;

  for (let index = 0; index < moteCount; index += 1) {
    const mote = document.createElement("span");
    mote.className = "aether-mote";
    mote.style.setProperty("--mote-x", `${Math.random() * 100}vw`);
    mote.style.setProperty("--mote-size", `${Math.random() * 4 + 2}px`);
    mote.style.setProperty("--mote-speed", `${Math.random() * 11 + 10}s`);
    mote.style.setProperty("--mote-delay", `${Math.random() * -18}s`);
    mote.style.setProperty("--mote-drift", `${Math.random() * 140 - 70}px`);
    fragment.appendChild(mote);
  }

  document.querySelector(".page-shell")?.appendChild(fragment);
};

const initIntroScreen = () => {
  if (!introScreen) {
    return;
  }

  const frequency = introScreen.dataset.introFrequency || "session";
  const storageKey = "amareIntroScreenSeen";
  const storage = frequency === "once" ? window.localStorage : window.sessionStorage;
  const shouldRemember = frequency !== "always";

  try {
    if (shouldRemember && storage.getItem(storageKey) === "true") {
      introScreen.remove();
      return;
    }
  } catch (error) {
    // Storage can be unavailable in private contexts; the intro should still work.
  }

  const video = introScreen.querySelector("[data-intro-video]");
  const enterButton = introScreen.querySelector("[data-intro-enter]");
  const skipButton = introScreen.querySelector("[data-intro-skip]");
  const minDelay = Math.max(0, Number(introScreen.dataset.introDelay) || 0);
  const openedAt = Date.now();
  let isClosing = false;

  document.body.classList.add("intro-screen-open");
  introScreen.classList.add("is-ready");

  const rememberIntro = () => {
    if (!shouldRemember) {
      return;
    }

    try {
      storage.setItem(storageKey, "true");
    } catch (error) {
      // Ignore storage failures; closing the overlay is more important.
    }
  };

  const closeIntro = () => {
    if (isClosing) {
      return;
    }

    isClosing = true;
    const remainingDelay = Math.max(0, minDelay - (Date.now() - openedAt));
    window.setTimeout(() => {
      rememberIntro();
      introScreen.classList.add("is-hidden");
      document.body.classList.remove("intro-screen-open");
      window.setTimeout(() => introScreen.remove(), 760);
    }, remainingDelay);
  };

  enterButton?.addEventListener("click", closeIntro);
  skipButton?.addEventListener("click", closeIntro);

  if (!video) {
    return;
  }

  const videoSrc = video.dataset.introSrc;
  if (videoSrc && video.getAttribute("src") !== videoSrc) {
    video.setAttribute("src", videoSrc);
  }

  video.addEventListener("ended", closeIntro);
  video.addEventListener("error", () => {
    introScreen.classList.add("has-video-error");
  });

  const playAttempt = video.play();
  if (playAttempt && typeof playAttempt.catch === "function") {
    playAttempt.catch(() => {
      introScreen.classList.add("needs-user-start");
      enterButton?.addEventListener(
        "click",
        () => {
          video.play().catch(() => closeIntro());
        },
        { once: true }
      );
    });
  }
};

const syncHeaderRankBadge = () => {
  if (!headerRankBadge) {
    return;
  }

  const rankCard = document.querySelector("[data-collector-rank]");
  const tier = rankCard?.querySelector(".collector-rank__sigil span")?.textContent?.trim();
  const title = rankCard?.querySelector(".collector-rank__body h2")?.textContent?.trim();

  if (!tier || !title) {
    return;
  }

  headerRankBadge.hidden = false;
  headerRankBadge.classList.remove("is-empty");
  headerRankBadge.querySelector("[data-header-rank-tier]").textContent = tier;
  headerRankBadge.querySelector("[data-header-rank-title]").textContent = title;
  headerRankBadge.setAttribute("aria-label", `Collector mantle: ${title}`);
};

const normalizeSecretCode = (value) => value.trim().toLowerCase().replace(/\s+/g, "");

const setSecretBoonMessage = (form, message, state = "") => {
  const messageElement = form.querySelector("[data-secret-message]");
  if (!messageElement) {
    return;
  }

  messageElement.textContent = message;
  messageElement.classList.toggle("is-error", state === "error");
  messageElement.classList.toggle("is-success", state === "success");
};

const unlockSecretBoon = (form, submittedCode) => {
  const expectedCode = normalizeSecretCode(form.dataset.secretCode || "");
  const destination = form.dataset.secretUrl;

  if (!expectedCode || !destination) {
    setSecretBoonMessage(form, "This gate is not fully inscribed yet.", "error");
    return false;
  }

  if (normalizeSecretCode(submittedCode) !== expectedCode) {
    setSecretBoonMessage(form, "That code did not open the gate.", "error");
    return false;
  }

  setSecretBoonMessage(form, "Gate opened.", "success");
  window.location.href = destination;
  return true;
};

const checkSecretBoonQuery = () => {
  if (!secretBoonForms.length) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const queryCode = params.get("boon_code") || params.get("code");

  if (!queryCode) {
    return;
  }

  Array.from(secretBoonForms).some((form) => {
    const input = form.querySelector("[data-secret-input]");
    if (input) {
      input.value = queryCode;
    }

    return unlockSecretBoon(form, queryCode);
  });
};

const pulseBattleVignette = () => {
  if (!battleVignette) {
    return;
  }

  battleVignette.classList.remove("is-casting");
  void battleVignette.offsetWidth;
  battleVignette.classList.add("is-casting");
};

const showCommandFeedback = (stage, message) => {
  let feedback = stage.querySelector(".command-feedback");
  if (!feedback) {
    feedback = document.createElement("div");
    feedback.className = "command-feedback";
    feedback.setAttribute("aria-live", "polite");
    stage.appendChild(feedback);
  }

  feedback.textContent = message;
  feedback.classList.add("is-visible");
  window.clearTimeout(feedback.hideTimer);
  feedback.hideTimer = window.setTimeout(() => feedback.classList.remove("is-visible"), 2200);
};

const spawnSummonParticles = (stage) => {
  const card = stage.querySelector(".sigil-card");
  const particleCount = lowPowerDevice ? 12 : 42;
  const rect = card?.getBoundingClientRect();
  const stageRect = stage.getBoundingClientRect();
  const originX = rect ? rect.left + rect.width / 2 - stageRect.left : stageRect.width / 2;
  const originY = rect ? rect.top + rect.height / 2 - stageRect.top : stageRect.height / 2;
  const fragment = document.createDocumentFragment();

  for (let index = 0; index < 2; index += 1) {
    const wave = document.createElement("span");
    wave.className = "summon-wave";
    wave.style.setProperty("--particle-x", `${originX}px`);
    wave.style.setProperty("--particle-y", `${originY}px`);
    wave.style.setProperty("--wave-delay", `${index * 110}ms`);
    fragment.appendChild(wave);
    window.setTimeout(() => wave.remove(), 1100 + index * 110);
  }

  for (let index = 0; index < particleCount; index += 1) {
    const particle = document.createElement("span");
    particle.className = `summon-particle summon-particle-${index % 3}`;
    particle.style.setProperty("--particle-x", `${originX}px`);
    particle.style.setProperty("--particle-y", `${originY}px`);
    particle.style.setProperty("--particle-size", `${Math.random() * 6 + 3}px`);
    particle.style.setProperty("--particle-angle", `${Math.random() * 360}deg`);
    particle.style.setProperty("--particle-distance", `${Math.random() * 170 + 60}px`);
    particle.style.setProperty("--particle-delay", `${Math.random() * 160}ms`);
    fragment.appendChild(particle);
    window.setTimeout(() => particle.remove(), 1250);
  }

  stage.appendChild(fragment);
};

const setCommandUnlocked = (stage) => {
  stage.dataset.summoned = "true";
  stage.classList.remove("is-summoning");
  void stage.offsetWidth;
  stage.classList.add("is-summoning");
  stage.classList.add("is-summoned");
  window.setTimeout(() => stage.classList.remove("is-summoning"), 1200);
  stage.querySelectorAll('[data-command="inspect"], [data-command="add-item"]').forEach((button) => {
    button.classList.remove("is-locked");
  });
};

const syncCartCount = async () => {
  if (!cartCount) {
    return;
  }

  const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
    headers: { Accept: "application/json" },
  });

  if (response.ok) {
    const cart = await response.json();
    cartCount.textContent = cart.item_count;
  }
};

const addFeaturedItem = async (stage) => {
  const variantId = stage.dataset.featuredVariantId;

  if (!variantId) {
    showCommandFeedback(stage, "Choose a featured product first");
    return false;
  }

  const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  });

  if (!response.ok) {
    showCommandFeedback(stage, "Relic could not be added");
    return false;
  }

  await syncCartCount();
  return true;
};

const handleRelicCommand = async (button) => {
  const stage = button.closest(".hero-visual");
  if (!stage) {
    return;
  }

  const command = button.dataset.command;
  const unlocked = stage.dataset.summoned === "true";

  if (command === "summon") {
    setCommandUnlocked(stage);
    pulseBattleVignette();
    spawnSummonParticles(stage);
    button.classList.add("is-confirmed");
    showCommandFeedback(stage, "Featured relic unveiled");
    return;
  }

  if (!unlocked) {
    button.classList.add("is-locked");
    pulseBattleVignette();
    showCommandFeedback(stage, "Summon the relic first");
    return;
  }

  if (command === "inspect") {
    window.location.href = stage.dataset.featuredUrl || window.Shopify?.routes?.root || "/";
    return;
  }

  if (command === "add-item") {
    button.disabled = true;
    const added = await addFeaturedItem(stage);
    button.disabled = false;
    if (added) {
      button.classList.add("is-confirmed");
      button.textContent = "Added";
      showCommandFeedback(stage, `${stage.dataset.featuredTitle || "Relic"} added to cart`);
    }
  }
};

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.2,
  }
);

revealItems.forEach((item) => revealObserver.observe(item));

const closeGalleryLightbox = () => {
  if (!galleryLightbox) {
    return;
  }

  galleryLightbox.classList.remove("is-open");
  galleryLightbox.setAttribute("aria-hidden", "true");
  document.body.classList.remove("lightbox-open");
};

if (productGalleryMain && productGalleryThumbs.length) {
  productGalleryThumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const imageSrc = thumb.dataset.galleryImageSrc;
      if (!imageSrc) {
        return;
      }

      productGalleryMain.src = imageSrc;
      productGalleryMain.alt = thumb.dataset.galleryImageAlt || productGalleryMain.alt;
      if (productGalleryFrame && thumb.dataset.galleryImageRatio) {
        productGalleryFrame.style.setProperty("--product-gallery-ratio", thumb.dataset.galleryImageRatio);
      }

      productGalleryThumbs.forEach((item) => {
        const isActive = item === thumb;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    });
  });
}

const bindGalleryDragGuard = (piece) => {
  let startX = 0;
  let startY = 0;

  piece.addEventListener(
    "pointerdown",
    (event) => {
      startX = event.clientX;
      startY = event.clientY;
      piece.dataset.galleryDragging = "false";
    },
    { passive: true }
  );

  piece.addEventListener(
    "pointermove",
    (event) => {
      if (Math.abs(event.clientX - startX) > 10 || Math.abs(event.clientY - startY) > 10) {
        piece.dataset.galleryDragging = "true";
      }
    },
    { passive: true }
  );

  const clearDragState = () => {
    window.setTimeout(() => {
      delete piece.dataset.galleryDragging;
    }, 90);
  };

  piece.addEventListener("pointerup", clearDragState, { passive: true });
  piece.addEventListener("pointercancel", clearDragState, { passive: true });
};

const closeMediaLightbox = () => {
  if (!mediaLightbox || !mediaLightboxImage) {
    return;
  }

  mediaLightbox.classList.remove("is-open");
  mediaLightbox.setAttribute("aria-hidden", "true");
  mediaLightboxImage.src = "";
  mediaLightboxImage.alt = "";
  document.body.classList.remove("lightbox-open");
};

const setPieceOrientation = (piece, orientation) => {
  piece.setAttribute("data-artwork-orientation", orientation);
  piece.querySelectorAll(".piece-toggle").forEach((toggle) => {
    const active = toggle.dataset.setOrientation === orientation;
    toggle.classList.toggle("is-active", active);
  });
};

const syncGalleryArtPreview = (piece, target) => {
  const art = piece?.querySelector(".frame-art");
  const image = piece?.dataset.galleryImage || "";

  if (!target) {
    return;
  }

  target.className = target.classList.contains("gallery-lightbox__art")
    ? "gallery-lightbox__art"
    : "gallery-focus-panel__art";
  target.style.backgroundImage = "";
  target.style.backgroundSize = "";
  target.style.backgroundPosition = "";

  if (!art) {
    return;
  }

  art.classList.forEach((className) => {
    if (className.startsWith("placeholder-")) {
      target.classList.add(className);
    }
  });

  if (image) {
    const artStyles = window.getComputedStyle(art);
    target.style.backgroundImage = artStyles.backgroundImage;
    target.style.backgroundSize = artStyles.backgroundSize;
    target.style.backgroundPosition = artStyles.backgroundPosition;
  }
};

const getGalleryIndexLabel = (piece) => {
  const index = Array.from(galleryPieces).indexOf(piece) + 1;
  return `${String(index).padStart(2, "0")} / ${String(galleryPieces.length).padStart(2, "0")}`;
};

const selectGalleryPiece = (piece, event) => {
  const title = piece.dataset.galleryTitle || "Untitled work";
  const medium = piece.dataset.galleryMedium || "Artwork placeholder";
  const state = piece.dataset.galleryState || "available";
  const aura = piece.dataset.galleryAura || (state === "soon" ? "Veiled relic" : "Lunar relic");

  activeGalleryPiece = piece;
  galleryPieces.forEach((galleryPiece) => galleryPiece.classList.remove("is-focused"));
  piece.classList.add("is-focused");

  if (galleryFocusTitle) {
    galleryFocusTitle.textContent = title;
  }
  if (galleryFocusMedium) {
    galleryFocusMedium.textContent = medium;
  }
  if (galleryFocusStatus) {
    galleryFocusStatus.textContent = state === "soon" ? "Veiled node" : state === "ascended" ? "Ascended node" : "Available node";
  }
  if (galleryFocusAura) {
    galleryFocusAura.textContent = aura;
  }
  if (galleryFocusCount) {
    galleryFocusCount.textContent = getGalleryIndexLabel(piece);
  }
  syncGalleryArtPreview(piece, galleryFocusArt);

  if (event) {
    spawnRuneBurst(event.clientX, event.clientY);
  }

  if (mobileEffectsLite) {
    piece.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }
};

const openGalleryPiece = (piece, event) => {
  if (!galleryLightbox || !galleryLightboxArt || !galleryLightboxTitle || !galleryLightboxMedium) {
    return;
  }

  const title = piece.dataset.galleryTitle || "Untitled work";
  const medium = piece.dataset.galleryMedium || "Artwork placeholder";
  const orientation = piece.getAttribute("data-artwork-orientation") || "portrait";
  selectGalleryPiece(piece, event);
  syncGalleryArtPreview(piece, galleryLightboxArt);

  galleryLightboxTitle.textContent = title;
  galleryLightboxMedium.textContent = medium;
  galleryLightbox.setAttribute("data-artwork-orientation", orientation);
  galleryLightbox.classList.add("is-open");
  galleryLightbox.setAttribute("aria-hidden", "false");
  document.body.classList.add("lightbox-open");
};

const applyGalleryFilter = (filter) => {
  const filterKey = {
    all: "archive",
    available: "available",
    ascended: "ascended",
    soon: "veiled",
  };
  const sigilKey = filterKey[filter] || filterKey.all;
  const activeMappings = {
    "--gallery-active-sigil-image": `var(--gallery-sigil-${sigilKey}-image)`,
    "--gallery-active-sigil-tint": `var(--gallery-sigil-${sigilKey}-tint)`,
    "--gallery-active-sigil-glow": `var(--gallery-sigil-${sigilKey}-glow)`,
    "--gallery-active-sigil-opacity": `var(--gallery-sigil-${sigilKey}-opacity)`,
    "--gallery-active-sigil-saturation": `var(--gallery-sigil-${sigilKey}-saturation)`,
    "--gallery-active-sigil-brightness": `var(--gallery-sigil-${sigilKey}-brightness)`,
    "--gallery-active-sigil-contrast": `var(--gallery-sigil-${sigilKey}-contrast)`,
    "--gallery-active-primary": `var(--gallery-matrix-${sigilKey}-primary)`,
    "--gallery-active-secondary": `var(--gallery-matrix-${sigilKey}-secondary)`,
    "--gallery-active-accent": `var(--gallery-matrix-${sigilKey}-accent)`,
    "--gallery-active-primary-wash": `var(--gallery-matrix-${sigilKey}-primary-wash)`,
    "--gallery-active-secondary-wash": `var(--gallery-matrix-${sigilKey}-secondary-wash)`,
    "--gallery-active-accent-wash": `var(--gallery-matrix-${sigilKey}-accent-wash)`,
  };
  galleryWall?.setAttribute("data-gallery-filter-state", filter);
  Object.entries(activeMappings).forEach(([property, value]) => {
    galleryWall?.style.setProperty(property, value);
  });

  galleryFilterButtons.forEach((button) => {
    button.classList.toggle("is-active", button.dataset.galleryFilter === filter);
  });

  galleryPieces.forEach((piece) => {
    const state = piece.dataset.galleryState || "available";
    const visible = filter === "all" || state === filter;
    piece.hidden = !visible;
    piece.classList.toggle("is-filtered-out", !visible);
  });

  const nextPiece = Array.from(galleryPieces).find((piece) => !piece.hidden);
  if (nextPiece) {
    selectGalleryPiece(nextPiece);
  }
};

const spawnRuneBurst = (x, y) => {
  if (!galleryRuneStage) {
    return;
  }

  const burst = document.createElement("div");
  burst.className = "rune-burst";
  burst.style.left = `${x}px`;
  burst.style.top = `${y}px`;
  galleryRuneStage.appendChild(burst);
  window.setTimeout(() => burst.remove(), 1000);
};

const hideHeader = () => {
  if (window.scrollY <= 2) {
    showHeaderBriefly();
    return;
  }

  siteHeader?.classList.remove("is-peeking");
  siteHeader?.classList.add("is-hidden");
};

const showHeaderBriefly = () => {
  if (!siteHeader) {
    return;
  }

  siteHeader.classList.remove("is-hidden");
  siteHeader.classList.remove("is-peeking");
  siteHeader.classList.add("is-peeking");
  window.clearTimeout(headerIdleTimer);
  if (window.scrollY <= 2) {
    return;
  }
  headerIdleTimer = window.setTimeout(hideHeader, 5000);
};

const syncHeaderVisibility = () => {
  if (!siteHeader) {
    return;
  }

  const delta = scrollY - lastScrollY;

  if (scrollY <= 2) {
    showHeaderBriefly();
  } else if (delta < -6) {
    showHeaderBriefly();
  } else if (delta > 6) {
    hideHeader();
    window.clearTimeout(headerIdleTimer);
  }

  lastScrollY = scrollY;
};

const flushFrame = () => {
  frameQueued = false;
  updateParallax();
  syncHeaderVisibility();
};

const queueFrame = () => {
  if (frameQueued) {
    return;
  }

  frameQueued = true;
  window.requestAnimationFrame(flushFrame);
};

if (galleryPieces.length && galleryLightbox && galleryLightboxArt && galleryLightboxTitle && galleryLightboxMedium) {
  galleryPieces.forEach((piece) => {
    if (!piece.dataset.galleryState) {
      const index = Array.from(galleryPieces).indexOf(piece);
      piece.dataset.galleryState = index % 5 === 4 ? "soon" : index % 3 === 1 ? "ascended" : "available";
    }
    if (!piece.dataset.galleryAura) {
      const auras = ["Lunar relic", "Solar relic", "Abyssal relic", "Divine relic", "Mechanical relic"];
      piece.dataset.galleryAura = auras[Array.from(galleryPieces).indexOf(piece) % auras.length];
    }
    setPieceOrientation(piece, piece.getAttribute("data-artwork-orientation") || "portrait");
    bindGalleryDragGuard(piece);

    piece.addEventListener("click", (event) => {
      if (piece.dataset.galleryDragging === "true") {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      openGalleryPiece(piece, event);
    });

    piece.querySelectorAll(".piece-toggle").forEach((toggle) => {
      toggle.addEventListener("click", (event) => {
        event.stopPropagation();
        const orientation = toggle.dataset.setOrientation || "portrait";
        setPieceOrientation(piece, orientation);
      });
    });
  });

  galleryCloseTriggers.forEach((trigger) => {
    trigger.addEventListener("click", closeGalleryLightbox);
  });

  galleryFilterButtons.forEach((button) => {
    button.addEventListener("click", () => applyGalleryFilter(button.dataset.galleryFilter || "all"));
  });

  galleryOpenButton?.addEventListener("click", () => {
    if (activeGalleryPiece) {
      const rect = activeGalleryPiece.getBoundingClientRect();
      openGalleryPiece(activeGalleryPiece, {
        clientX: rect.left + rect.width / 2,
        clientY: rect.top + rect.height / 2,
      });
    }
  });

  applyGalleryFilter("all");
  selectGalleryPiece(galleryPieces[0]);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeGalleryLightbox();
    }
  });
}

if (mediaLightbox && mediaLightboxImage) {
  document.addEventListener("click", (event) => {
    const image = event.target.closest(".product-media-image, .print-card__image, .sigil-card__image, .release-letter__image, .release-letter__gallery-item img");
    if (!image) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const src = image.currentSrc || image.src;
    if (!src) {
      return;
    }

    mediaLightboxImage.src = src;
    mediaLightboxImage.alt = image.alt || "Product image preview";
    mediaLightbox.classList.add("is-open");
    mediaLightbox.setAttribute("aria-hidden", "false");
    document.body.classList.add("lightbox-open");
  });

  mediaCloseTriggers.forEach((trigger) => {
    trigger.addEventListener("click", closeMediaLightbox);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMediaLightbox();
    }
  });
}

document.addEventListener("click", (event) => {
  const productCard = event.target.closest(".print-card[data-card-url]");
  if (!productCard) {
    return;
  }

  if (event.target.closest("a, button, input, select, textarea, label")) {
    return;
  }

  const href = productCard.dataset.cardUrl;
  if (href) {
    window.location.href = href;
  }
});

if (productForms.length) {
  productForms.forEach((form) => {
    const variantSelect = form.querySelector("[data-variant-select]");
    const priceValue = form.closest(".product-copy")?.querySelector("[data-product-price-value]");
    const addToCartButton = form.querySelector("[data-add-to-cart]");
    const paymentButtonWrap = form.querySelector("[data-payment-button-wrap]");

    if (!variantSelect || !priceValue || !addToCartButton) {
      return;
    }

    const syncVariantState = () => {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (!selectedOption) {
        return;
      }

      const price = selectedOption.dataset.variantPrice;
      const available = selectedOption.dataset.variantAvailable === "true";

      if (price) {
        priceValue.textContent = price;
      }

      addToCartButton.disabled = !available;
      addToCartButton.textContent = available ? "Claim relic" : "Relic sealed";

      if (paymentButtonWrap) {
        paymentButtonWrap.hidden = !available;
      }
    };

    variantSelect.addEventListener("change", syncVariantState);
    syncVariantState();
  });
}

const initAstralProductMap = (map) => {
  const nodes = Array.from(map.querySelectorAll("[data-astral-node]"));
  const title = map.querySelector("[data-astral-panel-title]");
  const status = map.querySelector("[data-astral-panel-status]");
  const copy = map.querySelector("[data-astral-panel-copy]");
  const size = map.querySelector("[data-astral-panel-size]");
  const price = map.querySelector("[data-astral-panel-price]");
  const aura = map.querySelector("[data-astral-panel-aura]");
  const link = map.querySelector("[data-astral-panel-link]");
  const art = map.querySelector("[data-astral-panel-art]");
  const card = map.querySelector("[data-astral-panel-card]");
  const image = map.querySelector("[data-astral-panel-image]");
  const stage = map.querySelector(".astral-product-map__stage");
  const panel = map.querySelector(".astral-product-panel");
  const lines = Array.from(map.querySelectorAll(".astral-product-map__lines line"));
  const previous = map.querySelector("[data-astral-prev]");
  const next = map.querySelector("[data-astral-next]");
  let activeIndex = 0;

  if (!nodes.length || !title || !status || !copy || !size || !price || !aura || !link) {
    return;
  }

  const centerNode = (node) => {
    if (!stage || !node) {
      return;
    }

    const stageRect = stage.getBoundingClientRect();
    const nodeRect = node.getBoundingClientRect();
    const nodeCenterX = nodeRect.left - stageRect.left + stage.scrollLeft + nodeRect.width / 2;
    const nodeCenterY = nodeRect.top - stageRect.top + stage.scrollTop + nodeRect.height / 2;
    const targetLeft = nodeCenterX - stage.clientWidth / 2;
    const targetTop = nodeCenterY - stage.clientHeight / 2;

    if (stage.scrollWidth > stage.clientWidth || stage.scrollHeight > stage.clientHeight) {
      stage.scrollTo({
        left: Math.max(0, targetLeft),
        top: Math.max(0, targetTop),
        behavior: "smooth",
      });
    }

    const stageFullyVisible = stageRect.top >= 0 && stageRect.bottom <= window.innerHeight;
    if (!stageFullyVisible) {
      node.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  };

  const lightRoute = (index) => {
    lines.forEach((line) => {
      const routeIndex = Number(line.dataset.routeIndex);
      const isLit = routeIndex === index || routeIndex === index + 1;
      line.classList.toggle("is-lit", isLit);
      line.classList.toggle("is-muted", !isLit);
    });
  };

  const pulsePanel = () => {
    if (!panel) {
      return;
    }

    panel.classList.remove("is-revealing");
    void panel.offsetWidth;
    panel.classList.add("is-revealing");
  };

  const activateStar = (node) => {
    node.classList.remove("is-activating");
    void node.offsetWidth;
    node.classList.add("is-activating");
  };

  const selectNode = (index, options = {}) => {
    activeIndex = (index + nodes.length) % nodes.length;
    const node = nodes[activeIndex];

    nodes.forEach((item) => {
      const isActive = item === node;
      item.classList.toggle("is-active", isActive);
      item.classList.toggle("is-muted", !isActive);
    });
    lightRoute(activeIndex);
    title.textContent = node.dataset.title || "";
    status.textContent = node.dataset.status || "";
    copy.textContent = node.dataset.copy || "";
    size.textContent = node.dataset.size || "";
    price.textContent = node.dataset.price || "";
    aura.textContent = node.dataset.aura || "";
    link.href = node.dataset.url || "#";

    if (art && node.dataset.sigilTint) {
      art.style.setProperty("--relic-glow", node.dataset.sigilTint);
    }

    if (card) {
      if (node.dataset.sigilImage) {
        card.style.setProperty("--panel-sigil-image", node.dataset.sigilImage);
      }
      if (node.dataset.sigilTint) {
        card.style.setProperty("--panel-sigil-tint", node.dataset.sigilTint);
      }
    }

    if (image) {
      if (node.dataset.image) {
        image.src = node.dataset.image;
        image.alt = node.dataset.title || "";
        image.hidden = false;
      } else {
        image.removeAttribute("src");
        image.hidden = true;
      }
    }

    if (!options.skipReveal) {
      activateStar(node);
      pulsePanel();
    }
    centerNode(node);
  };

  nodes.forEach((node, index) => {
    node.addEventListener("click", () => selectNode(index));
  });

  previous?.addEventListener("click", () => selectNode(activeIndex - 1));
  next?.addEventListener("click", () => selectNode(activeIndex + 1));
  selectNode(0, { skipReveal: true });
};

astralProductMaps.forEach(initAstralProductMap);

if (cartForm && cartTotal) {
  const formatMoney = (cents) => {
    const value = (Number(cents) || 0) / 100;
    return value.toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
    });
  };

  const syncCartQuantity = async (input) => {
    const cartItem = input.closest("[data-cart-item]");
    if (!cartItem) {
      return;
    }

    const lineKey = cartItem.dataset.lineKey;
    const quantity = Math.max(0, Number(input.value) || 0);
    input.value = quantity;

    const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: lineKey,
        quantity,
      }),
    });

    if (!response.ok) {
      return;
    }

    const cart = await response.json();
    const updatedItem = cart.items.find((item) => item.key === lineKey);

    if (!updatedItem || quantity === 0) {
      cartItem.remove();
    } else {
      const linePrice = cartItem.querySelector("[data-cart-line-price] strong");
      const lineComparePrice = cartItem.querySelector("[data-cart-line-price] span");
      if (linePrice) {
        linePrice.textContent = formatMoney(updatedItem.final_line_price);
      }
      if (lineComparePrice) {
        if (updatedItem.original_line_price !== updatedItem.final_line_price) {
          lineComparePrice.textContent = formatMoney(updatedItem.original_line_price);
          lineComparePrice.hidden = false;
        } else {
          lineComparePrice.hidden = true;
        }
      }
      input.value = updatedItem.quantity;
    }

    cartTotal.textContent = formatMoney(cart.total_price);
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }

    if (cart.item_count === 0) {
      window.location.reload();
    }
  };

  cartForm.addEventListener("click", (event) => {
    const minusButton = event.target.closest("[data-quantity-minus]");
    const plusButton = event.target.closest("[data-quantity-plus]");
    if (!minusButton && !plusButton) {
      return;
    }

    const field = event.target.closest("[data-quantity-field]");
    const input = field?.querySelector("[data-cart-quantity]");
    if (!input) {
      return;
    }

    const delta = plusButton ? 1 : -1;
    input.value = Math.max(0, (Number(input.value) || 0) + delta);
    syncCartQuantity(input);
  });

  cartForm.addEventListener("change", (event) => {
    const input = event.target.closest("[data-cart-quantity]");
    if (!input) {
      return;
    }

    syncCartQuantity(input);
  });
}

initIntroScreen();
syncHeaderRankBadge();

if (motionSafe) {
  createAetherMotes();
  headerIdleTimer = window.setTimeout(hideHeader, 5000);
  queueFrame();
  if (parallaxEntries.length) {
    window.addEventListener(
      "scroll",
      () => {
        scrollY = window.scrollY;
        queueFrame();
      },
      { passive: true }
    );
  }
  if (!lowPowerDevice) {
    window.addEventListener(
      "pointermove",
      (event) => {
        pointerX = event.clientX / window.innerWidth - 0.5;
        pointerY = event.clientY / window.innerHeight - 0.5;
        if (crystalCursor) {
          document.documentElement.style.setProperty("--cursor-x", `${event.clientX}px`);
          document.documentElement.style.setProperty("--cursor-y", `${event.clientY}px`);
        }
        queueFrame();
      },
      { passive: true }
    );
  }
}

commandButtons.forEach((button) => {
  button.addEventListener("click", () => handleRelicCommand(button));
});

secretBoonForms.forEach((form) => {
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    unlockSecretBoon(form, form.querySelector("[data-secret-input]")?.value || "");
  });
});

checkSecretBoonQuery();

window.addEventListener(
  "scroll",
  () => {
    if (!motionSafe) {
      scrollY = window.scrollY;
      queueFrame();
    }
  },
  { passive: true }
);

if (!motionSafe) {
  headerIdleTimer = window.setTimeout(hideHeader, 5000);
}
